import { BaseComposeModal } from '@/components/BaseComposeModal'
import { QuotedPostEmbed } from '@/components/QuotedPostEmbed'
import { strings } from '@/strings'
import type { QuoteContext } from '@/types/posts'

interface QuoteModalProps {
    isOpen: boolean
    onClose: () => void
    quoteContext: QuoteContext
}

export function QuoteModal({ isOpen, onClose, quoteContext }: QuoteModalProps) {
    return (
        <BaseComposeModal
            isOpen={isOpen}
            onClose={onClose}
            submitLabel={strings.profile.postComposer.post}
            placeholder={strings.compose.quotePlaceholder}
            quoteOf={quoteContext}
        >
            {/* Quoted post preview */}
            <div className="px-4 pt-3 pb-1 ml-11">
                <QuotedPostEmbed post={quoteContext.post} />
            </div>
        </BaseComposeModal>
    )
}
